export class Roles {
  static readonly SlipcaseReader = 'launchpad.SlipcaseReader';
  static readonly Admin = 'administration.Admin';
  static readonly Impersonator = 'administration.Impersonator';
  static readonly Reader = 'administration.Reader';
  static readonly NewsAdmin = 'launchpad.NewsAdmin';
  static readonly FormBuilderAdmin = 'launchpad.FormBuilderAdmin';
  static readonly TeamMemberAdmin = 'launchpad.TeamMemberAdmin';
}